/**
 * @desc 事件处理信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.EventProcessDTO>> {
  return defHttp.get({
    url: '/wap/event/process/info',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.EventProcessDTO>> {
  return defHttp.get({
    url: '/mock/wap/event/process/info',

    params,
  });
}
